import { isObjectV2 } from "Utils/global"
import { v4 as uuid } from "uuid"

// --------------- COLORS AND VAR ------------------- //
export const widthColumn = "250px"

// --------------- FUNCTIONS ------------------- //
export const getPipelineColumns = (pipelineColumns, dataChart, categoryData) => {
  if (!Array.isArray(pipelineColumns) || !Array.isArray(dataChart) || !categoryData) return []
  const allColumns = [...pipelineColumns]
  dataChart.forEach(data => {
    const columnName = data[categoryData]
    const columnAlreadyExist = allColumns.find(col => col === columnName)
    if (!columnAlreadyExist) {
      allColumns.push(columnName)
    }
  })
  return allColumns
}

export const getColumnsFillWithItems = (pipelineColumns, dataChart, categoryData, valueData) => {
  if (!Array.isArray(pipelineColumns) || !Array.isArray(dataChart)) return []
  const columnsPlanner = pipelineColumns.map(column => {
    const items = getItemsPerColumn(dataChart, column, categoryData, valueData)
    return {
      columnName: column,
      items: items,
    }
  })
  return columnsPlanner
}

const getItemsPerColumn = (dataChart, column, categoryData, valueData) => {
  if (!Array.isArray(dataChart) || !column) return []
  let items = []
  dataChart.forEach(data => {
    if (data[categoryData] === column) {
      const itemsAssociate = data[valueData]?.split("; ")
      items = itemsAssociate.map(item => ({ id: uuid(), content: item }))
    }
  })
  return items
}

// ------------- DRAG AND DROP FUNCTIONS ----------------//
export const getColumnsWithReorderItem = (columns, source, destination) => {
  if (!Array.isArray(columns || !isObjectV2(source) || !isObjectV2(destination))) return []
  const newColumns = [...columns]
  const columnToMoveItem = newColumns[source.droppableId]
  const itemToMove = columnToMoveItem.items[source.index]
  if (!columnToMoveItem.items) return []
  columnToMoveItem.items.splice(source.index, 1)
  columnToMoveItem.items.splice(destination.index, 0, itemToMove)
  return newColumns
}

export const getColumnsWithMovingItem = (columns, source, destination) => {
  if (!Array.isArray(columns || !isObjectV2(source) || !isObjectV2(destination))) return []
  const newColumns = [...columns]
  const columnToRemoveItem = newColumns[source.droppableId]
  const columnToAddItem = newColumns[destination.droppableId]
  const itemToMove = columnToRemoveItem.items[source.index]
  if (!columnToRemoveItem.items || !columnToAddItem.items) return []
  columnToRemoveItem.items.splice(source.index, 1)
  columnToAddItem.items.splice(destination.index, 0, itemToMove)
  return newColumns
}

export const getDestinationColumnName = (columns, destination) => {
  if (!Array.isArray(columns || !isObjectV2(destination))) return
  const destinationColumnPosition = destination?.droppableId
  const destinationColumnName = columns[destinationColumnPosition]?.columnName
  return destinationColumnName
}

export const getMovingElement = (columns, destination) => {
  if (!Array.isArray(columns) || !destination) return {}
  if (!destination.droppableId || typeof destination.index !== "number" || destination.index < 0)
    return {}
  return columns[destination.droppableId].items[destination.index]
}

export const getLastMoves = moves => {
  if (!Array.isArray(moves)) return []
  const result = moves.reduce((acc, move) => {
    const actualId = move?.movingElement?.id
    return { ...acc, [actualId]: move }
  }, {})
  const lastMoves = Object.values(result)
  return lastMoves
}
